import React from 'react'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import Group from 'components/utils/Group'
import Heading from 'components/Luxkit/Typography/Heading'
import Caption from 'components/Luxkit/Typography/Caption'
import { pluralizeToString } from 'lib/string/pluralize'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import SolidFireIcon from 'components/Luxkit/Icons/solid/SolidFireIcon'
import UrgencyLabel from 'components/Luxkit/Label/UrgencyLabel'
import PromotionLabel from 'components/Luxkit/Label/PromotionLabel'

interface Props {
  offerTitle: string;
  departureCity?: string;
  destinationCity?: string;
  promotionDetails: App.CruisePromotionDetails | null;
  cruiseLineImage?: string;
  cruiseLineName?: string;
  isSpecialOffer?: boolean;
}

function CruiseTileHeader({
  offerTitle,
  departureCity,
  destinationCity,
  promotionDetails,
  cruiseLineImage,
  cruiseLineName,
  isSpecialOffer,
}: Props) {
  return <Group gap={4} direction="vertical">
    <LabelGroup>
      {promotionDetails?.isNew && (
        <UrgencyLabel variant="positive">NEW</UrgencyLabel>
      )}
      {isSpecialOffer && (
        <PromotionLabel icon={<SolidFireIcon />} variant="premium">
          Special offer
        </PromotionLabel>
      )}
      {!!promotionDetails?.isEndingIn && promotionDetails.isEndingIn <= 7 && (
        <UrgencyLabel variant="critical2">
          OFFER ENDS IN{' '}
          {pluralizeToString(
            'day',
            promotionDetails.isEndingIn,
          ).toLocaleUpperCase()}
        </UrgencyLabel>
      )}
    </LabelGroup>
    <Group gap={4} direction="vertical">
      <Caption variant="large">
        {departureCity === destinationCity && <>Starts and ends in <b>{departureCity}</b></>}
        {departureCity !== destinationCity && <>Starts in <b>{departureCity}</b>. Ends in <b>{destinationCity}</b></>}
      </Caption>
      <Group gap={4} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading5" lineClamp={3}>{offerTitle}</Heading>
        {cruiseLineImage && (
          <CSSBreakpoint max="tablet">
            <ResponsiveImage
              id={cruiseLineImage}
              src={cruiseLineImage}
              width={75}
              quality="eco"
              alt={cruiseLineName}
              role="presentation"
            />
          </CSSBreakpoint>
        )}
      </Group>
    </Group>
  </Group>
}

export default CruiseTileHeader
